// 引入http相关勾子处理
import './http/http.js';

import prex from './prex.js';
import h5 from './h5/h5.js';
import base from './teacher/base.js';
import pBase from './parent/base.js';
import face from './face/face.js';
import ossToken from './teacher/oss-token.js';
import share from './share/share.js';
import deregister from './deregister/deregister.js';

export default {
  ...prex,
  ...h5,
  ...base,
  ...ossToken,
  ...pBase,
  ...face,
  ...share,
  ...deregister
};
